const FLAGS = {
  es: "🇪🇸",
  en: "🇺🇸",
  fr: "🇫🇷",
  de: "🇩🇪",
  it: "🇮🇹",
  pt: "🇵🇹",
  zh: "🇨🇳",
};

const LanguageFlag = ({ code, size = 18 }) => {
  const box = Number(size) || 18;
  return (
    <span
      aria-hidden="true"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: box,
        height: box,
        minWidth: box,
        fontSize: Math.round(box * 0.85),
        lineHeight: 1,
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      {FLAGS[code] || "🏳️"}
    </span>
  );
};

export default LanguageFlag;
